import React, { useState, useEffect } from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Box, Text } from '@pancakeswap/uikit'
import axios from 'axios'
import { ethers } from 'ethers'
import abi from '../../../abi/lottery.abi.json'

const moneyFormat = (value) => {
  return (+value)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const StyledCard = styled(Flex)`
  background: ${({ theme }) => theme.colors.cardBackground};
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-shadow: ${({ theme }) => (theme.isDark ? '' : '8px 12px 12px rgba(15, 20, 30, 0.12)')};
`

const StyledJackpot = styled(Text)`
  background: ${({ theme }) =>
    theme.isDark ? 'linear-gradient(90deg, #FFE259 0%, #FFA751 100%)' : theme.colors.hardTextColor};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-size: 36px;
  font-weight: 800;
`

const StyledJackpotDetailTitle = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textSubtle};
  @media screen and (max-width: 440px) {
    font-size: 12px;
  }
`

const StyledJackpotDetailSubtitle = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSubtle};
  @media screen and (max-width: 440px) {
    font-size: 10px;
  }
`

const StyledPlusSeparator = styled(Text)`
  self-align: center;
  self-justify: center;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 8px;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textSubtle};
`

const StyledBAYC = styled.img`
  right: -30px;
  @media screen and (max-width: 440px) {
    width: 160px;
    right: -15px;
  }

  @media screen and (max-width: 360px) {
    width: 80px;
    right: -10px;
  }
`

const Jackpot = ({ genericprovider }) => {
  const theme = useTheme()
  const [baycFloorPrice, setFloorPrice] = useState(0)
  const [jackpotSize, setJackpotSize] = useState(0)
  const contractAddress = '0x043C2e5100A7157c36D677af0BbD62F76bB7E7D7'
  const [priceUpdated, setPriceUpdated] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        if (priceUpdated) return
        axios
          .get('https://api.opensea.io/api/v1/collection/boredapeyachtclub?format=json')
          .then((boredapeyachtclub) => {
            const floorPrice = boredapeyachtclub.data.collection.stats.floor_price
            // get eth price in usd
            axios.get('https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd').then((ethusd) => {
              const ethPrice = ethusd.data.ethereum.usd
              const floorPriceUSD = floorPrice * ethPrice
              setFloorPrice(floorPriceUSD)
              setPriceUpdated(true)
            })
          })
      } catch (e) {
        console.error(e)
      }
    }, 10000)
    return () => clearInterval(interval)
  }, [priceUpdated])

  useEffect(() => {
    const contract = new ethers.Contract(contractAddress, abi, genericprovider)
    contract.functions
      .getCurrentJackpotSize()
      .then((resp) => {
        setJackpotSize(+ethers.utils.formatUnits(resp[0]))
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  return (
    <StyledCard
      style={{ background: theme.colors.cardBackground, position: 'relative', paddingTop: 20, paddingBottom: 20 }}
    >
      <Box style={{ flexGrow: 1, marginLeft: 20 }}>
        <Text style={{ color: theme.colors.hardTextColor }}>JACKPOT VALUE</Text>
        <StyledJackpot style={{}}>
          {jackpotSize && baycFloorPrice ? `$${moneyFormat(jackpotSize + baycFloorPrice)}` : 'Loading...'}
        </StyledJackpot>
        <Flex style={{ marginTop: 32 }}>
          <div>
            <StyledJackpotDetailTitle>
              {jackpotSize ? `$${moneyFormat(jackpotSize)}` : 'Loading...'}
            </StyledJackpotDetailTitle>
            <StyledJackpotDetailSubtitle>Prize from tickets</StyledJackpotDetailSubtitle>
          </div>
          <StyledPlusSeparator> + </StyledPlusSeparator>
          <div>
            <StyledJackpotDetailTitle>
              {baycFloorPrice ? `$${moneyFormat(baycFloorPrice)}` : 'Loading...'}
            </StyledJackpotDetailTitle>
            <StyledJackpotDetailSubtitle>BAYC #9419</StyledJackpotDetailSubtitle>
          </div>
        </Flex>
      </Box>
      <StyledBAYC src="/bayc_.png" alt="bayc" style={{ maxWidth: 238, position: 'absolute', bottom: 0 }} />
    </StyledCard>
  )
}

export default Jackpot
